import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
var _require = require("../bootstrap"),
  mount = _require.mount,
  unmount = _require.unmount,
  bootstrap = _require.bootstrap,
  getHzeroAppApi = _require.getHzeroAppApi;
var newBootstrap = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // eslint-disable-next-line
            if (window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__) {
              __webpack_public_path__ = window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__;
            }
            _context.next = 3;
            return bootstrap.apply(void 0, _args);
          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function newBootstrap() {
    return _ref.apply(this, arguments);
  };
}();
var newMount = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _require2,
      overWriteConfig,
      _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _require2 = require("../../index"), overWriteConfig = _require2.overWriteConfig;
            overWriteConfig({
              dvaAppInit: function dvaAppInit(app) {
                // 微前端子模块的加载
                app.use(require("./getMicroModuleRouters").default(app));
              },
              // 应该是globalModel 打错字了
              globalModal: function globalModal(app) {
                return require("./models/global").default(app);
              },
              dvaRootRouter: function dvaRootRouter() {
                return require('hzero-front/lib/router').default;
              },
              initC7nUiConfig: function initC7nUiConfig() {
                var c7nUiConfig = require('hzero-front/lib/utils/c7nUiConfig');
                if (c7nUiConfig.loadConfig) {
                  c7nUiConfig.loadConfig();
                }
              }
            }, true);
            return _context2.abrupt("return", mount.apply(void 0, _args2));
          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function newMount() {
    return _ref2.apply(this, arguments);
  };
}(); // 非qiankun启动

if (!window.__POWERED_BY_QIANKUN__) {
  newBootstrap();
  newMount();
} // qiankun协议接入

export { newMount as mount, unmount, newBootstrap as bootstrap,
// 可以不导出
getHzeroAppApi };